import { cva } from 'class-variance-authority'

export const cardStyles = cva('rounded-2xl', {
  variants: {
    bordered: {
      true: 'border-2 border-orange-200',
      false: '',
    },
  },
  defaultVariants: {
    bordered: false,
  },
})
